<div class="footer">

  <p>DMINT Copyright © {{ currentYear }}. All Rights Reserved.</p>
  
</div>